(function () {
  if (typeof document === 'undefined' || !window.LuggexCompare) return;

  if (window.LuggexCompareUI) { window.LuggexCompareUI.scan(document); return; }
  var instances = new WeakMap();
  var api = window.LuggexCompare;

  function parseJson(node) {
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function init(root) {
    if (instances.has(root)) return;
    var catalogNode = root.querySelector('[data-luggex-compare-catalog]');
    var seedNode = root.querySelector('[data-luggex-compare-seed]');
    var overridesNode = root.querySelector('[data-luggex-compare-overrides]');
    var rowsNode = root.querySelector('[data-luggex-compare-rows]');
    var groupsNode = root.querySelector('[data-luggex-compare-groups]');
    if (!catalogNode || !rowsNode) return;

    var catalog = api.applyOverrides(
      api.applySeed(parseJson(catalogNode) || [], parseJson(seedNode) || {}),
      parseJson(overridesNode) || {}
    );
    var rowDefs = parseJson(rowsNode) || [];
    var groups = parseJson(groupsNode) || [];
    var selected = (root.getAttribute('data-default-handles') || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean);
    if (selected.length < 3) return;

    const cleanups = [];
    let destroyed = false;
    const listen = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    };
    var observers = [];
    var focusTimers = new Set();
    var openFrame;

    var hideInput = root.querySelector('[data-luggex-hide]');
    var tableBody = root.querySelector('[data-luggex-body]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-luggex-column]'));
    var picker = root.querySelector('[data-luggex-picker]');
    var sticky = root.querySelector('[data-luggex-sticky]');
    var headerSentinel = root.querySelector('[data-luggex-header]');
    var openIndex = -1;
    var mq = window.matchMedia('(max-width: 749px)');

    function isMobile() {
      return mq.matches;
    }

    function visibleCount() {
      return api.columnCount(isMobile());
    }

    function currentColumns() {
      return selected.map(function (handle) {
        return api.productByHandle(catalog, handle);
      }).filter(Boolean);
    }

    function visibleColumns() {
      return currentColumns().slice(0, visibleCount());
    }

    function cellText(column, row) {
      var field = column.fields[row.key] || {};
      if (api.isEmptyRaw(field.raw)) return '—';
      return field.display == null || field.display === '' ? '—' : String(field.display);
    }

    function isClosestUsFit(column, row) {
      return row.key === 'size_weight|airline_fit' &&
        column.handle === 'zx-carry-on-20-zipperless-aluminum' &&
        cellText(column, row) !== '—';
    }

    function renderCell(column, row, index) {
      var text = cellText(column, row);
      if (isClosestUsFit(column, row)) {
        return '<div class="lcc-row__cell lcc-row__cell--fit" data-col="' + index + '">' +
          '<span class="lcc-fit-mark">Closest U.S. fit</span>' +
          '<span class="lcc-fit-copy">' + escapeHtml(text) + '</span></div>';
      }
      return '<div class="lcc-row__cell" data-col="' + index + '">' + escapeHtml(text) + '</div>';
    }

    function renderBody() {
      var columns = visibleColumns();
      var hide = !!(hideInput && hideInput.checked);
      tableBody.innerHTML = groups.map(function (group) {
        var fields = rowDefs.filter(function (row) { return row.group === group.key; });
        var visible = api.visibleRows(fields, columns, hide);
        if (!visible.length) return '';
        return '<section class="lcc-group"><h3 class="lcc-group__title">' + escapeHtml(group.label) + '</h3>' +
          visible.map(function (row) {
            var cells = columns.map(function (column, index) {
              return renderCell(column, row, index);
            }).join('');
            return '<div class="lcc-row" data-row-key="' + escapeAttr(row.key) + '">' +
              '<h4 class="lcc-row__label">' + escapeHtml(row.label) + '</h4>' +
              cells +
              '</div>';
          }).join('') +
          '</section>';
      }).join('');
    }

    function renderColumn(index) {
      var product = api.productByHandle(catalog, selected[index]);
      var card = cards[index];
      if (!product || !card) return;
      var img = card.querySelector('[data-luggex-image]');
      var name = card.querySelector('[data-luggex-name]');
      var price = card.querySelector('[data-luggex-price]');
      var shop = card.querySelector('[data-luggex-shop]');
      if (img) {
        var src = product.image && product.image.src;
        if (src) {
          img.src = src;
          img.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
        img.alt = (product.image && product.image.alt) || product.title || '';
      }
      if (name) name.textContent = product.title;
      if (price) price.textContent = product.price;
      if (shop) {
        shop.href = product.url;
        shop.hidden = !product.url;
      }
    }

    function renderPicker() {
      if (!picker || openIndex < 0) return;
      var count = visibleCount();
      picker.setAttribute('data-active-col', String(openIndex));
      var tabs = '';
      if (isMobile()) {
        tabs = '<div class="lcc__picker-tabs">' + selected.slice(0, count).map(function (handle, index) {
          var product = api.productByHandle(catalog, handle);
          var isCurrent = index === openIndex;
          var cls = 'lcc__picker-tab' + (isCurrent ? ' is-current' : '');
          return '<button type="button" class="' + cls + '" data-luggex-tab="' + index + '">' +
            '<span>' + escapeHtml(product ? product.title : '') + '</span>' +
            '<svg class="lcc-icon-down" width="8" height="5" viewBox="0 0 8 5" fill="none" aria-hidden="true"><path d="M1 1L4 4L7 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
            '</button>';
        }).join('') + '</div>';
      }
      var groups = api.groupCatalogBySeries(catalog);
      var body = '<div class="lcc__picker-body">' + groups.map(function (group) {
        var cards = group.products.map(function (product) {
          var active = product.handle === selected[openIndex];
          var taken = api.takenIndex(product.handle, selected.slice(0, count), openIndex) >= 0;
          var cls = 'lcc__card' + (active ? ' is-active' : '') + (taken ? ' is-taken' : '');
          var src = product.image && product.image.src ? product.image.src : '';
          var takenAttrs = taken ? ' disabled aria-disabled="true" tabindex="-1"' : '';
          return '<button type="button" class="' + cls + '" data-handle="' + escapeAttr(product.handle) + '"' + takenAttrs + '>' +
            '<div class="lcc__card-img-wrap">' +
            (src ? '<img src="' + escapeAttr(src) + '" alt="' + escapeAttr(product.title) + '" width="140" height="100" loading="lazy">' : '') +
            '</div>' +
            '<span class="lcc__card-name">' + escapeHtml(product.title) + '</span></button>';
        }).join('');
        return '<section class="lcc__series" data-series="' + escapeAttr(group.key) + '">' +
          '<h3 class="lcc__series-title">' + escapeHtml(group.label) + '</h3>' +
          '<div class="lcc__grid">' + cards + '</div></section>';
      }).join('') + '</div>';
      var closeBtn = isMobile()
        ? '<button type="button" class="lcc__picker-close" data-luggex-picker-close aria-label="Close">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3L13 13M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>'
        : '';
      picker.innerHTML = tabs + body + closeBtn;
    }

    function renderSticky() {
      if (!sticky) return;
      var items = sticky.querySelectorAll('[data-luggex-sticky-item]');
      currentColumns().forEach(function (product, index) {
        var item = items[index];
        if (!item) return;
        var nameNode = item.querySelector('[data-luggex-sticky-name]');
        var priceNode = item.querySelector('[data-luggex-sticky-price]');
        var shopNode = item.querySelector('[data-luggex-sticky-shop]');
        if (nameNode) nameNode.textContent = product.title;
        if (priceNode) priceNode.textContent = product.price;
        if (shopNode) {
          shopNode.href = product.url;
          shopNode.hidden = !product.url;
        }
      });
    }

    function setPickerOpen(open) {
      document.documentElement.classList.toggle('lcc-picker-open', open && isMobile());
    }

    function syncTriggers() {
      cards.forEach(function (card, cardIndex) {
        var button = card.querySelector('[data-luggex-select]');
        if (!button) return;
        var on = cardIndex === openIndex;
        button.setAttribute('aria-expanded', on ? 'true' : 'false');
        button.classList.toggle('is-open', on);
      });
      if (!sticky) return;
      Array.prototype.forEach.call(sticky.querySelectorAll('[data-luggex-sticky-select]'), function (button) {
        var on = Number(button.getAttribute('data-luggex-sticky-select')) === openIndex;
        button.setAttribute('aria-expanded', on ? 'true' : 'false');
        button.classList.toggle('is-open', on);
      });
    }

    function pickerTrigger() {
      if (sticky && !sticky.hidden) {
        var stickyBtn = sticky.querySelector('[data-luggex-sticky-select="' + openIndex + '"]');
        if (stickyBtn) return stickyBtn;
      }
      var card = cards[openIndex];
      return card ? card.querySelector('[data-luggex-select]') : null;
    }

    function placePicker() {
      if (!picker) return;
      if (isMobile()) {
        picker.style.top = '';
        picker.style.left = '';
        picker.style.width = '';
        picker.style.maxHeight = '';
        return;
      }
      var trigger = pickerTrigger();
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      var width = Math.min(472, window.innerWidth - 24);
      var left = rect.left + rect.width / 2 - width / 2;
      left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
      var spaceBelow = window.innerHeight - rect.bottom - 16;
      var spaceAbove = rect.top - 16;
      var maxH;
      var top;
      if (spaceBelow < 280 && spaceAbove > spaceBelow) {
        maxH = Math.min(600, Math.max(220, spaceAbove));
        top = Math.max(12, rect.top - maxH - 8);
      } else {
        maxH = Math.min(600, Math.max(220, spaceBelow));
        top = rect.bottom + 8;
      }
      picker.style.top = top + 'px';
      picker.style.left = left + 'px';
      picker.style.width = width + 'px';
      picker.style.maxHeight = maxH + 'px';
    }

    var closeTimer = null;
    function closePicker() {
      openIndex = -1;
      setPickerOpen(false);
      syncTriggers();
      if (!picker || picker.hidden) return;
      picker.classList.remove('is-open');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openIndex >= 0) return;
        picker.hidden = true;
        picker.removeAttribute('data-active-col');
        picker.style.top = '';
        picker.style.left = '';
        picker.style.width = '';
        picker.style.maxHeight = '';
      }, 300);
    }

    function openPicker(index) {
      if (index >= visibleCount()) return;
      var alreadyOpen = picker && !picker.hidden;
      openIndex = index;
      setPickerOpen(true);
      syncTriggers();
      if (!picker) return;
      clearTimeout(closeTimer);
      picker.hidden = false;
      renderPicker();
      placePicker();
      if (alreadyOpen) {
        picker.classList.add('is-open');
        return;
      }
      openFrame = requestAnimationFrame(function () {
        if (!destroyed && openIndex === index) picker.classList.add('is-open');
      });
    }

    function togglePicker(index) {
      if (openIndex === index) closePicker();
      else openPicker(index);
    }

    function renderAll() {
      cards.forEach(function (_, index) { renderColumn(index); });
      renderBody();
      renderSticky();
      if (openIndex >= 0) {
        if (openIndex >= visibleCount()) closePicker();
        else {
          renderPicker();
          placePicker();
        }
      }
    }

    function chooseProduct(handle) {
      if (openIndex < 0 || !handle) return false;
      if (api.takenIndex(handle, selected.slice(0, visibleCount()), openIndex) >= 0) return false;
      if (handle !== selected[openIndex]) {
        selected = api.replaceColumn(selected, openIndex, handle);
        renderColumn(openIndex);
        renderBody();
        renderSticky();
      }
      closePicker();
      return true;
    }

    function focusHandle(handle) {
      if (!handle) return;
      var count = visibleCount();
      var idx = selected.slice(0, count).indexOf(handle);
      if (idx < 0) {
        selected = api.replaceColumn(selected, 0, handle);
        idx = selected.slice(0, count).indexOf(handle);
        if (idx < 0) idx = 0;
        renderAll();
      }
      closePicker();
      var card = cards[idx];
      if (!card) return;
      card.classList.add('is-trip-focus');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var focusTimer = setTimeout(function () {
        focusTimers.delete(focusTimer);
        if (!destroyed) card.classList.remove('is-trip-focus');
      }, 1400);
      focusTimers.add(focusTimer);
    }

    listen(root, 'click', function (event) {
      var trip = event.target.closest('[data-luggex-trip]');
      if (trip && root.contains(trip)) {
        focusHandle(trip.getAttribute('data-luggex-trip'));
        return;
      }
      if (event.target.closest('[data-luggex-picker-close]')) {
        closePicker();
        return;
      }
      var tab = event.target.closest('[data-luggex-tab]');
      if (tab && picker && picker.contains(tab)) {
        openPicker(Number(tab.getAttribute('data-luggex-tab')));
        return;
      }
      var pickCard = event.target.closest('[data-handle]');
      if (pickCard && picker && picker.contains(pickCard)) {
        if (pickCard.disabled || pickCard.classList.contains('is-taken')) return;
        chooseProduct(pickCard.getAttribute('data-handle'));
        return;
      }
      var stickySelect = event.target.closest('[data-luggex-sticky-select]');
      if (stickySelect) {
        togglePicker(Number(stickySelect.getAttribute('data-luggex-sticky-select')));
        return;
      }
      var select = event.target.closest('[data-luggex-select]');
      if (select) {
        togglePicker(Number(select.getAttribute('data-luggex-select')));
        return;
      }
      var column = event.target.closest('[data-luggex-column]');
      if (column && !event.target.closest('[data-luggex-shop]')) {
        togglePicker(Number(column.getAttribute('data-col')));
        return;
      }
      if (!isMobile() && !event.target.closest('[data-luggex-picker]') && !event.target.closest('[data-luggex-sticky]')) {
        closePicker();
      }
    });

    listen(window, 'scroll', function () {
      if (openIndex >= 0 && !isMobile()) placePicker();
    }, { passive: true });
    listen(window, 'resize', function () {
      if (openIndex >= 0) placePicker();
    });

    listen(document, 'keydown', function (event) {
      if (event.key === 'Escape') closePicker();
    });

    listen(document, 'click', function (event) {
      if (openIndex < 0 || isMobile()) return;
      if (root.contains(event.target)) return;
      closePicker();
    });

    if (hideInput) listen(hideInput, 'change', renderBody);
    if (mq.addEventListener) listen(mq, 'change', renderAll);
    else if (mq.addListener) {
      mq.addListener(renderAll);
      cleanups.push(function () { mq.removeListener(renderAll); });
    }

    if (sticky && headerSentinel && 'IntersectionObserver' in window) {
      var headerVisible = true;
      var sectionVisible = true;
      function updateSticky() {
        sticky.hidden = !(sectionVisible && !headerVisible);
        if (openIndex >= 0) placePicker();
      }
      var headerObserver = new IntersectionObserver(function (entries) {
        if (destroyed) return;
        headerVisible = entries[0].isIntersecting;
        updateSticky();
      });
      headerObserver.observe(headerSentinel);
      observers.push(headerObserver);
      var sectionObserver = new IntersectionObserver(function (entries) {
        if (destroyed) return;
        sectionVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0 });
      sectionObserver.observe(root);
      observers.push(sectionObserver);
      updateSticky();
    }

    instances.set(root, function () {
      destroyed = true;
      if (openIndex >= 0) setPickerOpen(false);
      clearTimeout(closeTimer);
      focusTimers.forEach(clearTimeout);
      cancelAnimationFrame(openFrame);
      cleanups.forEach(function (cleanup) { cleanup(); });
      observers.forEach(function (observer) { observer.disconnect(); });
      instances.delete(root);
    });
    renderAll();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&amp;/g, '&')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  const rootsWithin = (scope) => [
    ...(scope.matches?.('[data-luggex-compare]') ? [scope] : []),
    ...scope.querySelectorAll('[data-luggex-compare]'),
  ];
  const scan = (scope) => rootsWithin(scope).forEach(init);
  window.LuggexCompareUI = { scan };
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsWithin(event.target).forEach((root) => instances.get(root)?.());
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

})();
